import callApi from './backendService';

const basePath = `/web/callback/one-to-one`;

export const exchangeCode = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/exchange`,
  body: data
});
